// extracted by mini-css-extract-plugin
export default {"container":"GenreInput_container__p2TIs","content":"GenreInput_content__UKF+C","activeGenre":"GenreInput_activeGenre__LJtAT","inactiveGenre":"GenreInput_inactiveGenre__mDGxr"};